import React from 'react';
import { Card } from 'react-bootstrap';
import { ServiceListImageLoader } from '../../utils/loaders/ServiceListImageLoader'

export const ServiceListLoader = () => (

  <div id="left-tabs-example-tabpane-services" aria-labelledby="left-tabs-example-tab-services" role="tabpanel" aria-hidden="false" class="fade service-list-loader tab-pane active show">
    <div className="floating-cards white-bg container">
      <fieldset>
        <legend className="visuallyhidden">Select a Service</legend>
        <ul id="content-loader" aria-label="Filter by Services" className="list-style row">
          <li className="button-checkbox col-md-4">
            <Card className='img-responsive-wrapper card-col '>
              <ServiceListImageLoader />
            </Card>
            <Card.Body className='services-card-body'>
              <Card.Title className="font-size-p2 gotham-xn-medium title-hover" ></Card.Title>
            </Card.Body>
          </li>
          <li className=" button-checkbox col-md-4">
            <Card className='img-responsive-wrapper card-col '>
              <ServiceListImageLoader />
            </Card>
            <Card.Body className='services-card-body'>
              <Card.Title className="font-size-p2 gotham-xn-medium title-hover" ></Card.Title>
            </Card.Body>
          </li>
          <li className=" button-checkbox col-md-4">
            <Card className='img-responsive-wrapper card-col '>
              <ServiceListImageLoader />
            </Card>
            <Card.Body className='services-card-body'>
              <Card.Title className="font-size-p2 gotham-xn-medium title-hover" ></Card.Title>
            </Card.Body>
          </li>
          <li className=" button-checkbox col-md-4">
            <Card className='img-responsive-wrapper card-col '>
              <ServiceListImageLoader />
            </Card>
            <Card.Body className='services-card-body'>
              <Card.Title className="font-size-p2 gotham-xn-medium title-hover" ></Card.Title>
            </Card.Body>
          </li>
          <li className=" button-checkbox col-md-4">
            <Card className='img-responsive-wrapper card-col '>
              <ServiceListImageLoader />
            </Card>
            <Card.Body className='services-card-body'>
              <Card.Title className="font-size-p2 gotham-xn-medium title-hover" ></Card.Title>
            </Card.Body>
          </li>
          <li className=" button-checkbox col-md-4">
            <Card className='img-responsive-wrapper card-col '>
              <ServiceListImageLoader />
            </Card>
            <Card.Body className='services-card-body'>
              <Card.Title className="font-size-p2 gotham-xn-medium title-hover" ></Card.Title>
            </Card.Body>
          </li>
        </ul>
      </fieldset>
    </div>
  </div>

)


